import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import moment from 'moment';
import { downloadInvoiceHistory } from '../../../../../actions';

class InvoicesHistory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fromDate: null,
            toDate: null
        };
    }

    changeState = ({ target }) => {
        let targetValue = target.value;
        // const time = '00:00:00';

        targetValue = target.value.split(/\D/);
        targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
        targetValue = moment(targetValue).format("DD-MM-YYYY")

        this.setState({
            [target.name]: targetValue
        })

    }

    onClear() {

        this.setState({
            fromDate: null,
            toDate: null
        },
        () => {
            document.getElementById("startDate").value = '';
            document.getElementById("endDate").value = '';
        });
    }

    downloadCustomers(restaurantId) {

        this.props.downloadInvoiceHistory(restaurantId, this.state.startDate, this.state.endDate, () => {
            this.onClear()
        })
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = this.props.styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.invoicesHistory')}</span>
            </div>
        );
    }

    renderBody() {
        const { cardContainer } = styles;
        const restaurantId = this.props.match.params.id;

        return (
            <Row xs={12} style={cardContainer}>
                <Col xs={4} style={{paddingRight: '0px'}}>
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                        <Label xs={4}>{i18n.t('screens:customersScreen.startDate')}</Label>
                        <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                            <Input 
                                id="startDate"
                                type="date" 
                                name="startDate"
                                onChange={this.changeState}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={4} style={{paddingLeft: '0px'}}>
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                        <Label xs={4}>{i18n.t('screens:customersScreen.endDate')}</Label>
                        <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                            <Input 
                                id="endDate"
                                type="date" 
                                name="endDate"
                                onChange={this.changeState}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={2}>
                    <Button 
                        disabled={!this.state.startDate || !this.state.endDate} 
                        color="primary" 
                        style={{ display: 'flex', alignItems: 'center'}}
                        onClick={() => this.downloadCustomers(restaurantId)} >
                        <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="cloud_download" color="#fff" size={18} /></span>
                        <span style={{marginLeft: '3px'}}>{i18n.t('common:buttons.download')}</span>
                    </Button>
                </Col>
            </Row>
        )
    }

    render() {
        
        return (
            <div>
                {this.renderHeader()}
                {this.renderBody()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        
    }
}

export default connect(mapStateToProps, {downloadInvoiceHistory})(InvoicesHistory);

const styles = {

    cardContainer: {
        // width: '70%',
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'space-between',
        padding: '15px',
        marginRight: '0px',
        paddingBottom: '10px'
        // margin: '0px 15px 0'
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/InvoicesHistory.js